import {
  FilterValueType,
  instanceOfOptionValueArray,
  instanceOfRangeValue,
  isMultiFilterValueType,
} from 'festo-react-ui-kit';
import RequestHandler from '../../app/RequestHandler';
import { isNumeric } from '../../helper';
import { FilterBaseType } from '../../type/FilterBaseType';

export type FilterValues = Record<string, string[] | string | boolean>;

export function getCurrentFilterValue(
  filter: FilterBaseType,
  newValue: (string | number)[],
): FilterValueType | FilterValueType[] | undefined {
  if (filter.value === undefined) {
    return undefined;
  }
  if (newValue === undefined) {
    return filter.value;
  }
  const { value } = filter;
  if (isMultiFilterValueType(value)) {
    return getMultiOptionValue(value, newValue);
  }
  return getSingleOptionValue(value, newValue);
}

function getMultiOptionValue(currentValue: FilterValueType[], newValue: (string | number)[]): FilterValueType[] {
  return currentValue.map((item) => ({ ...item, selected: newValue.includes(item.data) }));
}

function getSingleOptionValue(currentValue: FilterValueType, newValue: (string | number)[]): FilterValueType {
  let returnValue = currentValue;
  if (newValue.length > 0) {
    // updating single-option filter
    const data = newValue[0];
    if (data) {
      // validation for range number values
      if (instanceOfRangeValue(currentValue)) {
        if (isNumeric(data)) {
          let parsedData = 0;

          if (typeof data === 'number') {
            parsedData = data;
          } else if (typeof data === 'string') {
            parsedData = parseFloat(data);
          }

          if (parsedData >= currentValue.min && parsedData <= currentValue.max) {
            returnValue = { ...currentValue, data: parsedData, selected: true };
          }
        }
      } else {
        returnValue = { ...currentValue, data: data.toString(), selected: true };
      }
    }
  }
  return returnValue;
}

export function getValueData(filter?: FilterBaseType, selected = true): string[] | undefined {
  if (filter === undefined) {
    return undefined;
  }
  const { value } = filter;

  let data: string[] | undefined;
  if (value !== undefined) {
    if (isMultiFilterValueType(value)) {
      if (selected) {
        const selectedValue = value.filter((v: FilterValueType) => v.selected);
        if (selectedValue.length > 0) {
          data = selectedValue.map((filterValue: FilterValueType) => filterValue.data.toString());
        }
      } else {
        data = value.map((v: FilterValueType) => v.data.toString());
      }
    } else {
      data = [];
      data.push(value.data.toString());
    }
  }
  return data;
}

export function parseFilters(data: FilterBaseType[], type: string): FilterValues {
  const outputQuery: FilterValues = {};

  const requestHandler = new RequestHandler();
  const { applicationType } = requestHandler;
  let { country, language } = requestHandler;
  if (applicationType !== 'local'){
    language = '';
    country = '';
  }
  data.forEach((filter: FilterBaseType) => {
    const valueFromData = getValueData(filter);
    if (valueFromData) {
      if (type === 'backend' && (filter.key === 'additionalFunctions' || filter.key === 'environment' || filter.key === 'porous')) {
        valueFromData.forEach((value: string) => {
          outputQuery[value] = true;
        });
      } else {
        outputQuery[filter.key] = valueFromData;
      }
    }
  });
  if (language !== '') {
    outputQuery['language'] = language;
  }
  
  if (country !== '') {
    outputQuery['country'] = country;
  }
  return outputQuery;
}

export function getDisplayedValue(data: string[], filter: FilterBaseType): string | undefined {
  if (filter.value && instanceOfOptionValueArray(filter.value)) {
    return filter.value.find((option) => data[0] === option.data)?.label;
  }
  return data[0];
}
